import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';

const OnlineUsers = ({ size = 22, color = 'currentColor', className }) => (
  <FontAwesomeIcon
    icon={faUserCircle}
    className={className}
    style={{ fontSize: size, color, width: '1em', height: '1em' }}
  />
);

export default OnlineUsers;
